<template>
  <div>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-5">
                    <h4 class="card-title mb-0">
                      {{ $t('delivery.label.pending') }} <small class="text-muted"> {{ $t('delivery.label.orders') }}</small>
                    </h4>
                </div><!--col-->

                <div class="col-sm-7">
                    <header-button></header-button>
                </div><!--col-->
            </div><!--row-->
            <hr />
            <div class="row mt-4">
              <div class="col-sm-6">
                <h5 class="mb-3">{{ $t('delivery.label.filter_option') }}</h5>
                <b-form v-if="show">
                  <div class="form-group row">
                    <label for="" class="col-sm-3 col-form-label">{{ $t('delivery.label.batch_id') }}</label>
                    <div class="col-sm-3 form-row">
                      <b-form-input type="number" v-model="filter.batchId" :placeholder="$t('delivery.label.enter_batch_id')"></b-form-input>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="" class="col-sm-3 col-form-label">{{ $t('delivery.label.upload_order_date') }}</label>
                    <div class="col-sm-9 row">
                      <div class="col-sm-6 form-row">
                          <datepicker v-model="filter.uploadDateFrom" :format="customFormatter" input-class="form-control"></datepicker>
                        </div>
                        <div class="col-sm-6 form-row">
                          <datepicker v-model="filter.uploadDateTo" :format="customFormatter" input-class="form-control"></datepicker>
                        </div>
                    </div>
                  </div>
                  <b-form-fieldset
                    :label="$t('delivery.label.reference_no')"
                    :description="$t('delivery.label.please_enter_reference_no')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="text" v-model="filter.referenceNo" :placeholder="$t('delivery.label.enter_reference_no')"></b-form-input>
                  </b-form-fieldset>
                  <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('delivery.label.search') }}</b-button>
                  <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('delivery.label.reset') }}</b-button>
                </b-form>
              </div><!--col-->
            </div>
            <div class="row mt-4">
                <div class="col">
                    <div class="table-responsive">
                        <table class="table">
                          <colgroup>
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="10%">
                          </colgroup>
                          <thead>
                            <tr>
                              <th>{{ $t('delivery.label.batch_id') }}</th>
                              <th>{{ $t('delivery.label.service_code') }}</th>
                              <th>{{ $t('delivery.label.reference_no') }}</th>
                              <th>{{ $t('delivery.label.address') }}</th>
                              <th>{{ $t('delivery.label.postal_code') }}</th>
                              <th>{{ $t('delivery.label.country') }}</th>
                              <th>{{ $t('delivery.label.shipment_content') }}</th>
                              <th>{{ $t('delivery.label.delivery_name') }}</th>
                              <th>{{ $t('delivery.label.weight') }}</th>
                              <th>{{ $t('delivery.label.declared_value') }}</th>
                              <th>{{ $t('delivery.label.status') }}</th>
                              <th>{{ $t('delivery.label.api_failed_message') }}</th>
                              <th>{{ $t('delivery.label.operation') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(delivery, index) in deliverys" :key="index">
                              <td>{{ delivery.batch_request_id }}</td>
                              <td>{{ delivery.service_code }}</td>
                              <td>{{ delivery.reference_no }}</td>
                              <td>{{ delivery.address }} {{ delivery.address1 }} {{ delivery.address2 }}</td>
                              <td>{{ delivery.postal }}</td>
                              <td>{{ delivery.country }}</td>
                              <td>{{ delivery.shipment_content }}</td>
                              <td>{{ delivery.delivery_name }}</td>
                              <td>{{ delivery.weight }}</td>
                              <td>{{ delivery.declared_value }}</td>
                              <td v-html="delivery.status_label"></td>
                              <td>{{ delivery.api_failed_message }}</td>
                              <td>
                                <router-link :to="{ path: '/delivery/pending/' + delivery.id }">
                                  <b-button variant="info btn-sm" size="sm"><i class="fa fa-search"></i></b-button>
                                </router-link>
                                <router-link v-if="displayEditStatus.includes(delivery.status)" :to="{ path: '/delivery/pending/' + delivery.id + '/edit' }">
                                  <b-button variant="primary btn-sm" size="sm"><i class="fa fa-edit"></i></b-button>
                                </router-link>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="row">
                          <div class="col-sm-12 col-md-5">
                            <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
                          </div>
                          <div class="col-sm-12 col-md-7">
                            <nav>
                              <b-pagination align="end" :total-rows="this.meta.total" :per-page="this.meta.per_page" v-model="currentPage" :prev-text="$t('general.list.prev')" :next-text="$t('general.list.next')" @change='changePage' hide-goto-end-buttons/>
                            </nav>
                          </div>
                        </div>
                    </div>
                </div><!--col-->
            </div><!--row-->
        </div><!--card-body-->
    </div><!--card-->

    <CModal
      title="Delivery Quotation List"
      :show.sync="modalShow"
      color="primary"
      size="lg"
      ok-only
    >
      <delivery-quotation :detail="deliveryQuotations"></delivery-quotation>
    </CModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import DeliveryQuotation from './Quotation'
import HeaderButton from '@/views/components/delivery/pending/HeaderButton'
export default {
  name: 'pendingorders',
  components: {
    HeaderButton,
    datepicker,
    DeliveryQuotation
  },
  mounted () {
    this.axios.get('/delivery/pending').then(response => {
      this.deliverys = response.data
      this.meta = response.meta
    }).catch(error => {
      console.log(error)
    })
  },
  computed: {
    ...mapGetters([
      'deliveryQuotations'
    ])
  },
  data () {
    return {
      modalShow: false,
      displayEditStatus: [2, 4],
      deliverys: [],
      meta: [],
      filter: {
        batchId: null,
        uploadDateFrom: '',
        uploadDateTo: '',
        referenceNo: ''
      },
      currentPage: 1,
      show: true
    }
  },
  methods: {
    onReset () {
      // evt.preventDefault()
      this.filter.batchId = ''
      this.filter.referenceNo = ''
      this.filter.uploadDateFrom = moment().format('YYYY-MM-DD')
      this.filter.uploadDateTo = moment().add(1, 'day').format('YYYY-MM-DD')
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onSearchForm () {
      this.axios.get('/delivery/pending', {
        params: {
          batch_id: this.filter.batchId,
          reference_no: this.filter.referenceNo,
          waybill_number: this.filter.waybillNumber,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo
        }
      }).then(response => {
        this.deliverys = response.data
        this.meta = response.meta
        var vm = this
        response.data.forEach(function (deliveryOrder) {
          vm.referenceNos.push(deliveryOrder.id)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    changePage (pageNum) {
      // var url = 'crayola_sku=' + this.filterOption.crayolaSku + '&dc_sku=' + this.filterOption.dcSku + '&page=' + pageNum
      // required oninvalid="this.setCustomValidity('Please Enter valid email')"
      this.axios.get('/delivery/pending', {
        params: {
          batch_id: this.filter.batchId,
          reference_no: this.filter.referenceNo,
          waybill_number: this.filter.waybillNumber,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo,
          page: pageNum
        }
      }).then(response => {
        this.deliverys = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
